import { TRANSLATIONS_APP_NAME, TranslationsContext } from '@telia-common-components/shared';
import React from 'react';
import { Heading, Separator, Table, TableCell, TableRow, Text, Tooltip, TooltipToggle } from 'telia-front-react';
import { useTvPackageStore } from '../../stores/TvpackageStoreProvider';
import { mapPackageInclusionsToSections } from '../util/TvPackageOfferingCardUtil';
export const TvPackageInclusions = (props) => {
    const { productOfferingCode } = props;
    const { translate, translateOrEmpty } = React.useContext(TranslationsContext);
    const { tvPackageStore } = useTvPackageStore();
    const packageInclusions = tvPackageStore.getTvPackageInclusions(productOfferingCode);
    const sections = mapPackageInclusionsToSections(packageInclusions);
    const renderInfoRow = (text) => {
        if (!text) {
            return null;
        }
        const tooltip = translateOrEmpty(TRANSLATIONS_APP_NAME, `tvPackageOfferings.${text}.tooltip`);
        if (tooltip) {
            return (React.createElement(React.Fragment, null,
                React.createElement(TooltipToggle, { id: text }, translate(`tvPackageOfferings.${text}`)),
                React.createElement(Tooltip, { referenceElement: `#${text}` }, tooltip)));
        }
        else {
            return translate(`tvPackageOfferings.${text}`);
        }
    };
    return (React.createElement(Text, null,
        React.createElement(Heading, { level: 2, className: "h4" },
            React.createElement("strong", null, translate('tvPackageOfferings.includedInPackage'))),
        React.createElement(Separator, { color: "invisible", spacing: "xxsmall" }),
        sections.map((section, sectionIndex) => (React.createElement("div", { key: sectionIndex },
            React.createElement(Table, null,
                React.createElement("thead", null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, { padding: "small", type: 'th', colSpan: 2 },
                            React.createElement("strong", null, translate(section.title))))),
                React.createElement("tbody", null, section.items.map((_, itemIndex) => {
                    if (itemIndex % 2 === 0) {
                        return (React.createElement(TableRow, null,
                            React.createElement(TableCell, { padding: "small" }, renderInfoRow(section.items[itemIndex])),
                            React.createElement(TableCell, { padding: "small" }, renderInfoRow(section.items[itemIndex + 1]))));
                    }
                    else {
                        return null;
                    }
                }))))))));
};
